import { useSyncExternalStore } from 'react'

// Whether the device has a network connection. `navigator.onLine` false is
// reliable; true only means an interface is up, so a request can still fail.
const subscribe = (onChange: () => void) => {
	window.addEventListener('online', onChange)
	window.addEventListener('offline', onChange)
	return () => {
		window.removeEventListener('online', onChange)
		window.removeEventListener('offline', onChange)
	}
}

const getSnapshot = () => navigator.onLine

export const useOnline = (): boolean =>
	useSyncExternalStore(subscribe, getSnapshot)
